import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgBackdropComponent } from './ng-backdrop.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    NgBackdropComponent
  ],
  declarations: [
    NgBackdropComponent
  ]
})
export class NgBackdropModule { }
